import { Scanner } from "@yudiel/react-qr-scanner";

const QrScannerComponent = (props) => {


    return (
        <Scanner
            onDecode={(res) => props.setQr(res)}
            onError={(err) => props.setErr(err?.message)}
        />
    )
}

export default QrScannerComponent;